import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MeasurementCommunicatorService } from "../../../../toolbars-components/services/measurement-communicator.service";
import { MapService } from "../../../services/internal-services/map.service";
import { FeatureFlagsService } from "../../../services/internal-services/feature-flags.service";
import { FeatureFlags } from "../../../model/feature-flags";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-measurement-toolbar",
  templateUrl: "./measurement-toolbar.component.html",
  styleUrls: ["./measurement-toolbar.component.scss"],
  standalone: false,
})
export class MeasurementToolbarComponent {
  @Input()
  discreteEnabled: boolean = false;

  @Input()
  measurementToolAllowed: boolean = false;

  @Input()
  activeToolPanel: boolean = false;

  constructor(
    protected mapService: MapService,
    protected measurementCommunicatorService: MeasurementCommunicatorService,
    protected flagService: FeatureFlagsService,
  ) {}

  FeatureFlags = FeatureFlags;

  showToolsPanel() {
    this.activeToolPanel = !this.activeToolPanel;
    this.measurementCommunicatorService.setMeasuremenToolStatus(this.activeToolPanel);
  }
}
